/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Content } from '@styles/base.style'
import { Theme } from '@themes/theme'
import CouponInput from '@views/Coupon/CouponInput'

const CouponInputPopup: React.FC = () => {
  const contentCss = (theme: Theme) => css`height: 100%; overflow: auto; text-align: left;`
  return (
    <Content css={contentCss}>
      <CouponInput />
    </Content>
  )
}
export default observer(CouponInputPopup)
